import { render } from "./AddNewTimesheetFrequency.vue?vue&type=template&id=3df7422a"
import script from "./AddNewTimesheetFrequency.vue?vue&type=script&lang=js"
export * from "./AddNewTimesheetFrequency.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__